module.exports = "/_next/static/images/transaction-details-coin-a5bef913b5f76899ad776aabb980a273.svg";